import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderProduktBaseCommand } from "./ArbetsorderProduktBaseCommand";

export class AddArbetsorderProduktCommand extends ArbetsorderProduktBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddArbetsorderProduktCommand";

    constructor(handelssortimentId: number, produktId: number, arbetsorderId: number) {
        super(AddArbetsorderProduktCommand.$type, CommandType.Insert);
        this.handelssortimentId = handelssortimentId;
        this.produktId = produktId;
        this.arbetsorderId = arbetsorderId;
    }
}
